import PropTypes from 'prop-types';

export const ZergRushBannerDefaultProps = {
  message: null,
  reason: 'zerg-rush',
};

export const ZergRushBannerPropTypes = {
  message: PropTypes.string,
  reason: PropTypes.string,
};
